import { styled } from "../../styles/index.js";
import SystemLink from "@mui/material/Link";
import { rootShouldForwardProp } from "@mui/material/styles/styled";
const LinkRoot = styled(SystemLink, {
  shouldForwardProp: (prop) => rootShouldForwardProp(prop) || prop === "classes",
  name: "TrueLink",
  slot: "Root"
})(({ fontSize, top, position }) => {
  return {
    cursor: "pointer",
    "& > svg": {
      top: top || ".35rem",
      position: position || "relative",
      fontSize: fontSize || "1.5rem"
    }
  };
});
export {
  LinkRoot
};
//# sourceMappingURL=link.styles.js.map
